import element from 'element-ui';
import PublicText from './message.js'

export default {
  // 判断数组是否包含
  includes(arr1, arr2) {
    return arr2.every(val => arr1.includes(val));
  },
  beforeAvatarUpload(file) {
    const isJPG = file.type === "image/jpeg";
    const isPNG = file.type === "image/png";
    const isWebp = file.type === "image/webp";
    const isGif = file.type === "image/gif";
    const isBmp = file.type === "image/bmp";
    const isLt5M = file.size / 1024 / 1024 < 1;

    if (!isJPG && !isPNG && !isWebp && !isGif && !isBmp) {
      element.Message.error(PublicText.upLoadFileFormat);
    }
    if (!isLt5M) {
      element.Message.error(PublicText.upLoadFileSize);
    }
    return (isJPG || isPNG || isWebp || isGif || isBmp) && isLt5M;
  },
};

export function getLastWeekData() {//获得上周周一~周日的年月日

  var date = new Date();
  // 上周一的日期
  date.setDate(date.getDate() - 7 - date.getDay() + 1);
  let start_day = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + ' 00:00:00';

  // 上周日的日期
  date.setDate(date.getDate() + 6);
  let end_day = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + ' 23:59:59';
  let lastweek = [start_day, end_day];
  return lastweek
}
